import { FormSubmissionAnswer } from '../../../contracts/form-submission-answer.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class TextFormSubmissionAnswer extends FormSubmissionAnswer {
  static readonly TYPE_ID: string = 'a7e3f1b2c4d6e8f0a1b3c5d7e9f1a2b4';

  constructor(
    public readonly questionId: string,
    public readonly value: string,
  ) {
    super();
  }

  get $typeId(): string {
    return TextFormSubmissionAnswer.TYPE_ID;
  }

  static create(args: {
    questionId: string,
    value: string,
  }): TextFormSubmissionAnswer {
    return new TextFormSubmissionAnswer(args.questionId, args.value);
  }

  static fromMap(context: SerializationContext, map: SerializedData): TextFormSubmissionAnswer {
    return new TextFormSubmissionAnswer(
        MapUtils.getString(map, 'questionId'),
        MapUtils.getString(map, 'value'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'questionId': this.questionId,
      'value': this.value,
    };
  }

  clone(): this {
    return new TextFormSubmissionAnswer(this.questionId, this.value) as this;
  }

  isSame(other: TextFormSubmissionAnswer): boolean {
    if(other === this) {
      return true;
    }

    return other.questionId === this.questionId &&
      other.value === this.value;
  }
}

export class TextFormSubmissionAnswerBuilder extends DataModelBuilder<TextFormSubmissionAnswer> {
  build(context: SerializationContext, map: SerializedData): TextFormSubmissionAnswer {
    return TextFormSubmissionAnswer.fromMap(context, map);
  }
}
